import { useMemo } from "react";
import usePaginatedApiData from "../../../hooks/usePaginatedApiData";
import { buildPaginationParams } from "../../../utils/pagination";

export default function useMembershipEventsData({
  page,
  pageSize,
  searchTerm,
  filters,
  orderBy,
  orderDirection,
}) {
  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        status: filters?.status || undefined,
        event_type: filters?.event_type || undefined,
        program_area: filters?.program_area || undefined,
        target_audience: filters?.target_audience || undefined,
        sort_by: orderBy,
        sort_dir: orderDirection,
      }),
    [
      page,
      pageSize,
      searchTerm,
      filters?.status,
      filters?.event_type,
      filters?.program_area,
      filters?.target_audience,
      orderBy,
      orderDirection,
    ],
  );

  const { data, totalCount, loading, error, refetch } = usePaginatedApiData({
    endpoint: "/membership/events",
    params,
    errorMessage: "Failed to load events",
  });

  return { events: data, totalCount, loading, error, refetch };
}
